import { Injectable } from '@angular/core';
import { Platform, AlertController } from '@ionic/angular';

import * as JsSIP from 'jssip';
import { AudioService } from '../audio/audio.service';
import {ConfigurationService} from '../configuration.service';
import {Events} from '../events';
import { RegisteredEvent } from 'jssip/lib/UA';
import { SipConfig } from 'src/app/interfaces/sip-config';

declare let window: any;
// declare var cordova: any;

@Injectable()
export class SipProvider {

  myua: JsSIP.UA;
  myuaNOVO: JsSIP.UA;
  message: any; // JsSIP.Message;
  registered = false;
  private socket: JsSIP.WebSocketInterface;
  private novoSocket: JsSIP.WebSocketInterface;
  inputReady = '';
  registerNOVO = false;
  isFallBack = false;
  private remoteAudio: HTMLAudioElement;
  private connectInterval: any;
  private callSession: any; // JsSIP.RTCSession;
  // JsSIP RTCSession.connection?: RTCPeerConnection
  private callConnection: any;
  public session: any; // JsSIP.RTCSession;
  public sessionNOVO: any; // JsSIP.RTCSession;

  constructor(public config: ConfigurationService, public platform: Platform,
              private alertCtrl: AlertController, public events: Events, private audio:AudioService) {

    this.audio.preload('incomingCallAudio', 'original_nokia_mp3.mp3');
    this.audio.preload('incomingMessageAudio', 'message_3mp3.mp3');
    this.audio.preload('incomingMessagePlingAudio', 'whatsapp_web.mp3');

    this.remoteAudio = new window.Audio();
    this.remoteAudio.volume = 1;
    this.remoteAudio.autoplay = true;
  }

  async showAlert(title: string) {
    const alert = await this.alertCtrl.create({
      header: title,
      inputs: [{
        type: 'text',
        name: 'myid'
      }],
      buttons: ['Übernehmen']
    });

    await alert.present();
    const data = await alert.onDidDismiss();
    return data;
  }

  private setMediaBitrate(sdp, media, bitrate) {

    const lines = sdp.split('\n');
    let line = -1;

    for (let i = 0; i < lines.length; i++) {
      if (lines[i].indexOf('m=' + media) === 0) {
        line = i;
        break;
      }
    }

    if (line === -1) {
      console.debug('Could not find the m line for', media);
      return sdp;
    }
    console.debug('Found the m line for', media, 'at line', line);

    // Pass the m line
    line++;

    // Skip i and c lines
    while (lines[line].indexOf('i=') === 0 || lines[line].indexOf('c=') === 0) {
      line++;
    }

    // If we're on a b line, replace it
    if (lines[line].indexOf('b') === 0) {
      console.debug('Replaced b line at line', line);
      lines[line] = 'b=AS:' + bitrate;
      return lines.join('\n');
    }

    // Add a new b line
    console.debug('Adding new b line before line', line);
    let newLines = lines.slice(0, line);
    newLines.push('b=AS:' + bitrate);
    newLines = newLines.concat(lines.slice(line, lines.length));
    return newLines.join('\n');
  }

    setBandwidth(sdp) {
      const audioBandwidth = 128;
      const videoBandwidth = 256;
      return this.setMediaBitrate(this.setMediaBitrate(sdp, 'video', videoBandwidth), 'audio', audioBandwidth);
    }

  socketAlive() {
    if (this.socket) {
      this.socket.send('alive');
    }
  }

  registerNOVOConnect(): Promise<JsSIP.UA | any> {
    return new Promise((resolve, reject) => {
      const conf: SipConfig = this.config.getValue('sipConfig');

      if (!this.novoSocket) {
        this.novoSocket = new JsSIP.WebSocketInterface(conf.wsServers);
      }

      const sipConf = conf;

      conf.password = 'Dgk26TMs';
      conf.authorizationUser = 'NOVOWEB';
      conf.uri = conf.uri.replace(/sip:.*@/, 'sip:' + conf.authorizationUser + '@');
      conf.contact_uri = conf.contact_uri.replace(/sip:.*@/, 'sip:' + conf.authorizationUser + '@');

      sipConf.sockets = [this.novoSocket];

      this.myuaNOVO = new JsSIP.UA(sipConf);

      this.myuaNOVO.on('registered', () => {
        resolve(this.myuaNOVO);
        this.registerNOVO = true;
      });

      this.myuaNOVO.on('unregistered', () => {
        this.registerNOVO = false;
      });

      this.myuaNOVO.on('registrationFailed', function(e) {
        console.log('registrationFailed');
        console.log(e);
        this.registerNOVO = false;
        reject(e);
      });

      this.myuaNOVO.on('newRTCSession', (ev) => {
        const newSession = ev.session;
        this.sessionNOVO = null;

        if (this.sessionNOVO) { // hangup any existing call
          this.sessionNOVO.terminate();
        }
        this.sessionNOVO = newSession;
      });

      this.myuaNOVO.start();
    });
  }

  unregisterNOVO() {
    if (this.registerNOVO) {
      this.myuaNOVO.stop();
      this.myuaNOVO.unregister();
    }
  }

  unregister() {
    if (this.myua) {
      this.myua.stop();
      this.myua.unregister();
      this.myua = null;
    }

    if(this.socket) {
      this.socket.disconnect();
    }
      
    this.registered = false;
    this.socket = null;
  }

  logout() {
    this.unregisterNOVO();
    this.unregister();
    if(this.myua) {
      this.myua.stop();
      this.myua = null;
    }
    
    this.session = null;

    setTimeout(() => {
      if (this.connectInterval) {
        clearInterval(this.connectInterval);
        this.connectInterval = null;
      }
    }, 5000);
  }

  registerSIPConnection(username = '', password = ''): Promise<RegisteredEvent> {
    return new Promise(async (resolve, reject) => {
      console.log(username, password);

      this.inputReady = localStorage.getItem('prom');
      const conf:any = this.config.getValue('sipConfig');
      let sp:string = this.config.getValue("socketUrl");
      sp = sp.split(":")[1].replace("//","");
      let sp2:string = this.config.getValue("secSocketUrl");
      sp2 = sp2.split(":")[1].replace("//","");

      if(this.isFallBack) {
        conf.wsServers = conf.wsServers.replace(sp, sp2);
        conf.contact_uri = conf.contact_uri.replace(sp, sp2);
        conf.uri = conf.uri.replace(sp, sp2);
      } else {
        conf.wsServers = conf.wsServers.replace(sp2, sp);
        conf.contact_uri = conf.contact_uri.replace(sp2, sp);
        conf.uri = conf.uri.replace(sp2, sp);
      }

      if (!this.socket) {
        this.socket = new JsSIP.WebSocketInterface(conf.wsServers);
      }

      const sipConf = conf;

      if (!this.inputReady) {
        const input: any = await this.showAlert('Bitte Benutzername eingeben');
        conf.authorizationUser = input.myid;
        conf.uri = conf.uri.replace('sip:6001', 'sip:' + input.myid);
        conf.contact_uri = conf.contact_uri.replace('sip:6001', 'sip:' + input.myid);
        this.inputReady = input.myid;
      } else {
        conf.authorizationUser = this.inputReady;
        conf.uri = conf.uri.replace('sip:6001', 'sip:' + this.inputReady);
        conf.contact_uri = conf.contact_uri.replace('sip:6001', 'sip:' + this.inputReady);
      }


      sipConf.sockets = [this.socket];

      if (!this.myua) {

        if(this.isFallBack && sp) { 
          sipConf.contact_uri = sipConf.contact_uri.replace(sp, sp2);
          sipConf.uri = sipConf.uri.replace(sp, sp2);
        } else {
          sipConf.contact_uri = sipConf.contact_uri.replace(sp2, sp);
          sipConf.uri = sipConf.uri.replace(sp2, sp);
        }

        this.myua = new JsSIP.UA(sipConf);
      } else if (!this.myua.isRegistered()){
        this.myua.register();
        return;
      }

      this.myua.on('newMessage', (ev: any) => {
        if (ev.originator === 'remote') {
          if (ev.request.body.indexOf('<mrs>') !== -1) {
            if (ev.request.body.indexOf('<mre>1</mre>') !== -1) {
              this.registerNOVOConnect().then((myua) => {
                this.startCall(this.inputReady, { audio: true, video: false }, myua);
              }, (e) => {
                console.log(e);
              });
            }
          } else {
            if (!document.querySelector('app-page-chat')) {
              this.audio.play('incomingMessageAudio');
            } else {
              this.audio.play('incomingMessagePlingAudio');
            }
            this.events.publish('onNewMessage', ev);
          }
        }
      });

      this.myua.on('newRTCSession', (ev) => {
        const newSession = ev.session;
        this.session = null;

        if (this.session) { // hangup any existing call
          this.session.terminate();
        }
        this.session = newSession;

        const completeSession = function() {
          this.session = null;
          this.audio.stop('incomingCallAudio');
          this.events.publish('onUpdateUI', this.session);
        }.bind(this);


        this.session.on('ended', completeSession);
        this.session.on('failed', completeSession);
        this.session.on('accepted', function() { this.events.publish('onSessionAccepted', this.session); this.events.publish('onUpdateUI', this.session); }.bind(this));
        this.session.on('confirmed', function() {this.events.publish('onSessionConfirmed', this.session); this.events.publish('onUpdateUI', this.session); }.bind(this));
        this.session.on('connecting', () => {console.log('connecting')});

        this.session.on('sdp', function(e) {
          if (e.originator === 'remote') {
            e.sdp = this.setBandwidth(e.sdp);
          }
        }.bind(this));

        if (this.session.direction === 'incoming') {
          this.audio.loop('incomingCallAudio');
        }

        this.events.publish('onUpdateUI', this.session);
      });

      this.myua.on('registered', (e:RegisteredEvent) => {

        this.events.publish('sip:registert', true);

        this.registered = true;
        if (this.connectInterval) {
          clearInterval(this.connectInterval);
          this.connectInterval = null;
        }

        resolve(e);
        console.log('registerd', e);

      });

      this.myua.on('unregistered', (e:RegisteredEvent) => {

        this.events.publish('sip:registert', false);
        this.registered = false;

        if (this.connectInterval) {
          clearInterval(this.connectInterval);
        }

        this.connectInterval = setInterval(() => {
          this.registerSIPConnection();
        }, 30000);

        this.myua.stop();
        this.myua = null;

        console.log('unregistered', e);
      });

      this.myua.on('registrationFailed', (e:RegisteredEvent) => {
        this.unregister();
        console.log('registrationFailed');
        console.log(e);

        this.socket = null;
        this.myua = null;

        reject(e);
      });

      this.myua.start();
    });
  }

  async startCall(callerNumber: string, mediaConstraints = { audio: true, video: false }, myua= this.myua) {
    const eventHandlers = {
      progress: (e: any) => {
        this.events.publish('onProgress', e);
        console.log('call is in progress' + e);
      },
      failed: (e: any) => {
        console.log('call failed with cause:', e);
        this.events.publish('onFailed', e);
      },
      ended: (e: any) => {
        console.log('call ended with cause: ' + e);
        this.events.publish('onEnded', e);
      },
      confirmed: (e: any) => {
        console.log('call confirmed' + e);
        this.events.publish('onConfirmed', e);
      }
    };

    const options = {
      eventHandlers,
      mediaConstraints
    };

    const parameters = {
      param_name: 'param_value',
      valueless_param: null
    };

    const headers = {
      header_name: 'header_value',
      multi_header: 'multi_header_value1'
    };

    const conf: any = this.config.getValue('sipConfig');
    const url = conf.uri.split('@');

    const uri = new JsSIP.URI('sip', callerNumber, url[1], conf.port, parameters, headers);

    // TODOALEX: Still working?
    this.callSession = myua.call(uri as unknown as string, options);
    this.callConnection = this.callSession.connection;
    this.callConnection.onaddstream = (ev: any) => {
      this.events.publish('onSelfStream', (this.callConnection.getLocalStreams()[0]));
      this.events.publish('onRemoteStream', (ev.stream));
    };
  }

  hangUp() {
    if (this.session && this.session.isInProgress()) {
      this.session.terminate();
      this.session = null;
    } else if (this.session && this.session.isEstablished()) {
      this.session.terminate();
      this.session = null;
    }

    if (this.sessionNOVO && this.sessionNOVO.isInProgress()) {
      this.sessionNOVO.terminate();
      this.sessionNOVO = null;
    } else if (this.sessionNOVO && this.sessionNOVO.isEstablished()) {
      this.sessionNOVO.terminate();
      this.sessionNOVO = null;
    }
  }

  answer(mediaConstraints: any = { audio: true, video: true }) {
    // if(mediaConstraints.video && this.platform.is("ios")) {
    //   mediaConstraints.video = {
    //     deviceId: 'com.apple.avfoundation.avcapturedevice.built-in_video:1',
    //     width: {
    //       min: 320,
    //       max: 640
    //     },
    //     frameRate: {
    //       min: 2.0,
    //       max: 30.0
    //     },
    //     facingMode: 'environment'
    //   },
    //   {
    //     audio: {
    //       deviceId: 'Built-In Microphone'
    //     }
    //   }
    // }

    const callOptions = {
      mediaConstraints
    };

    this.session.answer(callOptions);
    this.audio.stop('incomingCallAudio');

    (this.session.connection as any).ontrack = function(ev: any) {
      this.events.publish('onTrack', ev);
    }.bind(this);

    this.session.connection.addEventListener('addstream', function(ev: any) {
      this.audio.stop('incomingCallAudio');
      this.events.publish('onSelfStream', (this.session.connection.getLocalStreams()[0]));
      this.events.publish('onIncomingStream', (ev.stream));
    }.bind(this));

  }

  sendMessage(callerNumber: string, text: string) {
    return new Promise((resolve, reject) => {
      const eventHandlers = {
        succeeded(e){ resolve(e); },
        failed(e){ reject(e); }
      };

      const options = {
        eventHandlers
      };

      this.myua.sendMessage('sip:' + callerNumber, text, options);
    });
  }


  async gotDevices(deviceInfos) {

    const mediaDevices = {audioinput: [], audiooutput: [], videoinput: []};

    /*
    if(this.platform.is("android")) {
      deviceInfos = await cordova.plugins.EnumerateDevicesPlugin.getEnumerateDevices();
    }
    */

    return new Promise((resolve) => {
      // Handles being called several times to update labels. Preserve values.

      console.log(JSON.stringify(deviceInfos));


      for (let i = 0; i !== deviceInfos.length; ++i) {
        const deviceInfo = deviceInfos[i];
        if (deviceInfo.kind === 'audioinput') {
          mediaDevices.audioinput.push({label: deviceInfo.label, id: deviceInfo.deviceId});
          console.log(deviceInfo.label, deviceInfo.deviceId);
        } else if (deviceInfo.kind === 'audiooutput') {
          console.log(deviceInfo.label, deviceInfo.deviceId);
          mediaDevices.audiooutput.push({label: deviceInfo.label, id: deviceInfo.deviceId});
        } else if (deviceInfo.kind === 'videoinput') {
          console.log(deviceInfo.label, deviceInfo.deviceId);
          mediaDevices.videoinput.push({label: deviceInfo.label, id: deviceInfo.deviceId});
        } else {
          console.log('Some other kind of source/device: ', deviceInfo);
        }
      }
      resolve(mediaDevices);
    });

  }

}
